export const CONTRIBUTION_TYPE_SHALLOW_FRAGMENT = `
  fragment ContributionTypeShallowFragment on ContributionType {
    __typename
    id
    name
  }
`;
//# sourceMappingURL=contributionType.js.map